import { enameledSkillet } from './recipes/enameledSkillet.js';
import { enameledPan } from './recipes/enameledPan.js';
import { nonstickPan } from './recipes/nonstickPan.js';

export const range = {
  id: '3-range',
  name: 'Range',
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
  ],
  faceSize: 1024,
  initialViewParameters: {
    yaw: -0.4382331666393746,
    pitch: 0.4600840203993961,
    fov: 1.4254872060750312,
  },
  linkHotspots: [
    {
      yaw: -1.595066613785857,
      pitch: 0.6084860996221213,
      rotation: 7.0685834705770345,
      target: '5-right',
    },
    {
      yaw: 2.850863622611554,
      pitch: 0.17192791411114783,
      rotation: 14.922565104551524,
      target: '2-island',
    },
    {
      yaw: -3.0419891475199563,
      pitch: -0.012386579291812083,
      rotation: 9.42477796076938,
      target: '1-dining',
    },
    {
      yaw: -2.466045869551234,
      pitch: 0.07309652536443068,
      rotation: 8.63937979737193,
      target: '4-left',
    },
    {
      yaw: 1.449361898182823,
      pitch: 0.10334914079853874,
      rotation: 15.707963267948973,
      target: '0-countertop',
    },
  ],
  infoHotspots: [
    {
      yaw: -0.1257534730040195,
      pitch: 0.5426779238511568,
      title: 'Modular Sheet Pans',
      text: `
<ul>
<li><span class='b'> #100597</span></li>
<li> <span class='b'>USD</span> $40 | <span class='b'>CAD</span> $55</li>
<li> 3-year guarantee</li>
<li> Dishwasher-safe | Freezer-safe</li>
<li> Broiler-safe to 550°F (290°C). Safe to use in convection and conventional ovens. </li>
<li> (1) Medium: 8¾" x 12¾" (22.5 cm x 32 cm).<br/> (2) Small: 6¼" x 8¾" (16 cm x 22.5 cm).</li>
<li> Three high-quality sheet pans made from the same heavy-gauge steel as our other popular sheet pans, so they won’t warp in the broiler and will cook food evenly.</li>
<li> The high sides keep food from overflowing and the high-quality coating prevents food from sticking and keeps your pan looking great. </li>
<li> Add foods at different stages and season them separately, so everything turns out perfect. </li>
<li> Divide ingredients with different cooking times. Distribute heat evenly and nest in our other sheet pans, so you can store and move them easily.</li>
<li> The smaller pans also fit in our Deluxe Air Fryer.</li>

</ul>
       `,
      images: [
        { id: `by0cqswd1j`, key: `nc1-gs2-1` },
        { id: `gur4kjksya`, key: `nc1-gs2-2` },
        { id: `ak8u74bypy`, key: `nc1-gs2-3` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570016962" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: -0.9552222627556564,
      pitch: 0.20942608439118082,
      title: 'Enameled Cast<br/> Iron Skillet',
      subhead: 'Enameled Cast Iron Skillet With Lid',
      text: `
<ul>
<li><span class='b'> #100594</span></li>
<li> <span class='b'>USD</span> $170 | <span class='b'>CAD</span> $225</li>
<li> Lifetime guarantee</li>
<li> Dishwasher-safe | Heat-safe up to 500°F (260°C).</li>
<li> Induction-safe | PFOA- and PTFE-free </li>
<li> 4 qts. (3.8 L); 13¾" x 4½" (34.5 cm x 12 cm) with handles and lid.</li>
<li> Classic gray skillet with a light-colored enameled interior.</li>
<li> The perfect combo of an enameled cast iron skillet and Dutch oven! Plus, it requires no seasoning, and retains high heat.</li>
<li> Wide cooking surface, shallow sides, two sturdy handles, and oven-to-table design.</li>
<li> Self-basting lid adds juices back into whatever you’re cooking for added moisture and flavor. </li>
<li> <span class='b'>Great for:</span> braising, baking, sauteing, simmering, or roasting meat, veggies, and more.</li>
<li> <span class="b teal-text">Get it at a discount or for free when you host a party. Ask your consultant for details.</span></li>
</ul>
        `,
      images: [
        { id: `klujpkchec`, key: `nc1-gs1-31` },
        { id: `vhrzkj2ysz`, key: `nc1-gs1-32` },
        { id: `8ywhbmzgw7`, key: `nc1-gs1-33` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999990" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
      recipes: enameledSkillet.recipes,
    },
    {
      yaw: -1.0223026936630148,
      pitch: 0.9187916071057476,
      title: 'Enameled Cast<br/> Iron Pan',
      subhead: '14" x 10" (35-cm x 25-cm) Enameled Cast Iron Pan',
      text: `
<ul>
<li> <span class='b'> #100593</span></li>
<li> <span class='b'>USD</span> $199 | <span class='b'>CAD</span> $245</li>
<li> Pan: Lifetime guarantee<br/>Rack: 3-year guarantee</li>
<li> Dishwasher-safe | Heat-safe up to 500°F (260°C).</li>
<li> PFOA- and PTFE-free </li>
<li> 8-qt. (7.6-L) capacity; 17½" x 10¾" x 3½" (44.5 cm x 27 cm x 9 cm) with handles</li>
<li> Classic gray skillet with a light-colored enameled interior. Two sturdy handles and oven-to-table design.</li>
<li> Perfect size for special occasions and everyday meals. Plus, it requires no seasoning, and retains high heat.</li>
<li> Includes a stainless rack that lets air circulate around roasts and small turkeys for even cooking. The rack’s handles sit up high so they’re easy to grab and fold for storage.</li>
<li> Higher sides (3½"/9 cm) help keep food from bubbling over. </li>
<li> <span class='b'>Great for:</span> roasts, small turkeys, baked pastas, lasagnas, and other casseroles.</li>
<li><span class="b teal-text">Get it at a discount or for free when you host a party. Ask your consultant for details.</span></li>
</ul>
        `,
      images: [
        { id: `szlucbwdai`, key: `nc1-gs1-34` },
        { id: `laqzkb7l3t`, key: `nc1-gs1-35` },
        { id: `ngp3hyccqv`, key: `nc1-gs1-36` },
        { id: `ayxxpqqsju`, key: `nc1-gs1-37` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999953" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
      recipes: enameledPan.recipes,
    },
    {
      yaw: -0.2944372904824739,
      pitch: 0.05770602368511035,
      title: 'Spice Organizer',
      text: `
<ul>
<li><span class='b'> #100485</span></li>
<li> <span class='b'>USD</span> $30 | <span class='b'>CAD</span> $40</li>
<li> 1-year guarantee</li>
<li> Hand wash</li>
<li> 16" x 10¼" x 3" (40 cm x 25.5 cm x 7.5 cm)</li>
<li> Made of plastic. Four pieces: Two 2-step trays and two drawers.</li>
<li> Keep cooking and baking items neatly organized with our expandable, adjustable organizer that maximizes cabinet or pantry space. </li>
<li> Two drawers, a small and a large, tuck under the shelves for extra space to store small items.</li>
<li> Can hold up to 30 spice bottles. </li>
<li> <span class='b'>Great for:</span> spices, Enrichables™ pouches, yeast, birthday candles, drink packets, and more.</li>
<li> Also in the <span class="b">Spice & Storage Set:</span> Spice Organizer, Garlic & Herb Rub, Southwest Seasoning Mix, Italian Seasoning Mix, Three Onion Rub</li>

</ul>
        `,
      images: [
        { id: `w59q0rwjr7`, key: `nc1-gs3-9` },
        { id: `b5ieno6mxj`, key: `nc1-gs3-10` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570000023" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: 0.21864896515734245,
      pitch: 0.104388481481692,
      title: 'Kitchen Spritzer',
      text: `
<ul>
<li><span class='b'> #100475</span></li>
<li> <span class='b'>USD</span> $30 | <span class='b'>CAD</span> $35</li>
<li> 3-year guarantee</li>
<li> Dishwasher-safe: Container, sleeve, cap, and collar.<br/> Hand wash: Nozzle and washer.</li>
<li> 6¾" (17.5 cm); 3.5-oz. (100-mL) capacity to the max fill line. </li>
<li> Non-aerosol spritzer can easily and evenly coat food and control the amount of oil you add in everyday cooking without any of the additives.</li>
<li> Spritz oil on your bakeware and cookware to prevent food from sticking without it leaving behind that difficult-to-clean sticky residue often caused by canned sprays.</li>
<li> The refillable bottle has a filter to minimize clogs and lets you add dried herbs and spices to create your own infused oils. The clear plastic container lets you see when it’s time for a refill. </li>
<li> <span class='b'>Great for:</span> salads, meat, fish, veggies, air frying, barbecuing, and baking.</li>

</ul>
        `,
      images: [
        { id: `qxiechokjl`, key: `nc1-gs3-11` },
        { id: `angohewwjx`, key: `nc1-gs3-12` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/569999832" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: -0.1294910402052416,
      pitch: -0.18072231582460851,
      title: 'TasteBuds & Pantry',
      text: `
<ul>
<br/>
<br/>
<span class="title">TasteBuds Monthly Subscription</span>
<li>Choose from three subscription options for as little as <br/> USD $18 | CAD $25.50
per month: Month to Month, 3 Month Prepaid, or 6 Month Prepaid.</li>
<li>Automatic Renewals | Skip or Cancel Any Time | Free Shipping With Subscription</li>
<li>If you've ever spent hours scrolling for recipes only to make the same chicken dinner you make every week, we feel you. Let TasteBuds do the work for you. Monthly delivery, endless inspiration.<span class="b"> Each month you'll receive:</span></li>
<li><span class="b">3 seasonings:</span> Each month is a new theme, and you'll get 3 packets of our seasoning blends, enough for 2–4 recipes each. Some of the seasonings are our most-loved, sometimes subscribers get early access to new seasonings, and subscribers may even receive seasonings that are exclusive to TasteBuds! Each resealable pouch contains 4 tbsp (60 mL) of seasoning or rub.</li>
<li><span class="b">3 exclusive recipes:</span>Each recipe card includes cooking tips and ways to make it your own.</li>
<li><span class='b'>Additional seasoning uses: </span>Learn how to easily spice up snacks, sides, veggies, apps, and even drinks!</li>
<li> <span class='b'>Online access: </span>Get exclusive access to additional recipes, timesaving tips, and more.</li>
<li> <span class='b'>Add-Ons Marketplace: </span>Shop from a selection of helpful items and get free shipping with your subscription.</li>
<li>  Subscriptions ship at the beginning of the month. New subscriptions made after the 16th of the month will begin with the following month's box.</li>
<br/>
<br/>
<span class="title">Everything Bagel Seasoning</span>
<li><span class='b'>#100505</span></li>
<li> <span class='b'>USD</span> $8 | <span class='b'>CAD</span> $9</li>
<li> Gluten-Free, Kosher | Contains sesame</li>
<li> 3.6 oz. (102 g)</li>
<li> A perfect blend of sesame seeds, poppy seeds, garlic, and onion.</li>
<li> Enjoy the great flavors of everything bagels on everything.</li>
<li> <span class='b'>Great for:</span> buttered popcorn, avocado toast, salads, sandwich spreads, roasted veggies, meats, and more.</li>

<span class="b-italic">NEW in Canada!</span>
<span class="title">Beer Bread Mix</span>
<li><span class="b">#100429</span></li>
<li><span class="b"> USD</span> $7 | <span class="b">CAD</span> $9</li>
<li> Kosher | Contains wheat, barley. </li>
<li> 19 oz. (539 g)</li>
<li>Add a bubbly beverage to this mix for delicious bread in under an hour! </li>

<span class='b-italic'>NEW in Canada!</span>
<span class="title">French Toast Popcorn Seasoning</span>
<li><span class="b">#9058</span></li>
<li><span class="b>USD</span> $8 | <span class="b">CAD</span> $10</li>
<li> Kosher, Gluten-Free | Contains milk.</li>
<li> 5.5 oz. (155 g)</li>
<li> Sweet and maple-flavored. </li>
<li> Sprinkle over freshly made popcorn to add some variety.</li>

<span class='b-italic'>NEW in Canada!</span>
<span class="title">Ranch Popcorn Seasoning</span>
<li><span class='b'> #9057</span></li>
<li><span class="b>USD</span> $8 | <span class="b">CAD</span> $10</li>
<li>Kosher, Gluten-Free | Contains milk.</li>
<li>4.4 oz. (124 g)</li>
<li>Tangy and slightly sweet, with a little bite. </li>
<li>Sprinkle over freshly made popcorn to add some variety.</li>

<span class='b-italic'>NEW in Canada!</span>
<span class="title">Garlic-Infused Canola Oil</span>
<li><span class="b">#9677</span></li>
<li><span class="b">USD</span> $16 | <span class="b">CAD</span> $18</li>
<li>Gluten-Free</li>
<li>8 fl. oz. (236 mL).</li>
<li>Add real garlic flavor to your favorite dishes.</li>
<li><span class='b'>Great for:</span> bread, meats, vegetables, salad dressings, and more.</li>
</ul>
        `,
      images: [
        {
          contain: 'contain',
          id: `xauyzqfdgt`,
          key: `post-tastebuds-1-usca.jpg`,
        },
        { id: `ys8bwvnnix`, key: `nc1-gs2-22` },
        { id: `nj5wus2e3a`, key: `nc1-gs1-23` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/585028349" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
        `<iframe src="https://player.vimeo.com/video/569999722" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> `,
      ],
    },
    {
      yaw: -0.6383763830149967,
      pitch: 0.3138108898439018,
      title: 'Nonstick Saute &amp; Steam Pan',
      text: `<ul>
        <li><span class="b">#100368</span></li>
<li> <span class="b">USD</span> $245 | <span class="b">CAD</span> $325</li>
<li> Pan: Lifetime guarantee Removable<br/> Handle: 5-year guarantee Strainer and Helper<br/> Handle: 3-year guarantee</li>
<li> Dishwasher-safe | Heat-safe to 480°F (250°C) | PFOA-free</li>
<li> 11" x 11" (28 cm x 28 cm) without handles</li>
<li> Includes nonstick pan with removeable handle, strainer, helper handle protector, and lid with stainless rim.</li>
<li> This multifunctional meal maker features our top-of-the-line, titanium-reinforced nonstick coating that’s perfect for everyday cooking and so strong you can use metal utensils on the pan without scratching.</li>
<li> Designed without interior rivets so there’s no place for residue or rust to form.</li>
<li> Removable handle makes cooking in the oven, storing, and washing easier than ever. </li>
<li> Strainer collapses to use as a trivet.</li>
<li> Helper handle protector makes it safe and easy to move the pan around while it’s hot.</li>
<li> Tempered glass lid is heat-safe to 400°F (200°C) and also fits our Nonstick Grill Pan.</li>
<li><span class="b">Great for:</span> steaming, frying, sauteing, or baking all your family favorites.</li>
<li><span class="b teal-text">Get it at a discount or for free when you host a party. Ask your consultant for details.</span></li>
</ul>`,
      images: [
        { id: `cp9t88bzi5`, key: `nc1-gs1-11` },
        { id: `isbgo8ootl`, key: `nc1-gs1-12` },
        { id: `fvqsrjs78f`, key: `nc1-gs1-13` },
        { id: `v8jox4taix`, key: `nc1-gs1-14` },
      ],
      videos: [
        `<iframe src="https://player.vimeo.com/video/570017077" width="640" height="564" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`,
      ],
      recipes: nonstickPan.recipes,
    },
  ],
};
